export const INSURANCE_COMPANY_BATCH_TYPE_INVOICE = '31';
